import { withRouter } from "react-router-dom";

import React, { useEffect, useRef } from 'react';

import {
  LinearProgress,
  Box,
  Button
} from '@mui/material';

import Products from "../../components/Products";
import ProductFiltersBar from "../../components/ProductFilters/FilterBar";
import { useSelector, useDispatch } from 'react-redux';

import Actions from "../../constants/Actions";
import useDebounce from "../../utils/useDebounce";
import buscarProdutosComFiltros from "../../actions/v2/produtos/buscarProdutosComFiltros";
import carregarFacetsProdutos from "../../actions/v2/produtos/carregarFacetsProdutos";
import listaFiliais from "../../actions/cadastro/lista-filiais";

function OrderPage() {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading);
  const loadingPage = useSelector(state => state.loadingPage);
  const loadingProducts = useSelector(state => state.loadingProducts);
  const search = useSelector(state => state.search);
  const filters = useSelector(state => state.filters);
  const filialOptions = useSelector(state => state.filialOptions);
  const filterFacets = useSelector(state => state.filterFacets);
  const productsPagination = useSelector(state => state.productsPagination);

  const debouncedFilters = useDebounce(filters, 400);
  const didMountRef = useRef(false);

  const hasMore = productsPagination?.hasMore || false;
  const currentPage = productsPagination?.page || 1;
  const pageSize = productsPagination?.pageSize || 60;
  const total = productsPagination?.total || 0;

  const handleLoadMore = () => {
    buscarProdutosComFiltros(dispatch, {
      search,
      filters: debouncedFilters,
      page: currentPage + 1,
      pageSize,
      silent: true
    });
  };

  // Carrega opções de filial uma única vez
  useEffect(() => {
    if (!filialOptions || filialOptions.length === 0) {
      listaFiliais()
        .then(filiais => {
          dispatch({
            type: Actions.SET_FILIAL_OPTIONS,
            filialOptions: filiais
          });
        })
        .catch(err => console.error('Erro ao carregar filiais:', err));
    }
  }, []);

  // Opções dos dropdowns quando a página abre sem busca prévia (ex.: F5):
  // sem isso não há o que escolher, e o vendedor precisa poder filtrar sem termo.
  useEffect(() => {
    if (!filterFacets) {
      carregarFacetsProdutos(dispatch, { search });
    }
  }, []);

  // Re-busca quando filtros (debounced) mudam — pulando o primeiro mount
  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    buscarProdutosComFiltros(dispatch, {
      search,
      filters: debouncedFilters,
      page: 1,
      silent: true
    });
  }, [debouncedFilters]);

  const showLoading = loading === true || loadingPage === true || loadingProducts === true;

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {showLoading && <LinearProgress />}

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        {/* Filtros no topo */}
        <ProductFiltersBar />

        <Box sx={{ mt: 2 }}>
          <Products />
          {hasMore && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button
                variant="contained"
                onClick={handleLoadMore}
                disabled={loadingProducts}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  bgcolor: '#1a1a2e',
                  '&:hover': { bgcolor: '#2a2a3e' }
                }}
              >
                {loadingProducts ? 'Carregando...' : `Carregar mais (${Math.max(total - currentPage * pageSize, 0)} restantes)`}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default withRouter(OrderPage);
